import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";

class RechargeExplain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // document.title = '充电卡购买协议';
    return (
      <div className="page_type_h5">
        <div id="reChargeExplain">
          <p className="header">
            尊敬的用户，为保障您的合法权益，请您在购买前仔细阅读本《充电卡购买协议》（本协议）以了解远程慧联APP的充电卡购买和使用规则，避免产生任何误解，本协议适用于远程慧联APP及其关联公司的充电服务。当您点击“立即购买”按钮，即视为您已阅读、并同意按照本协议约定的规则进行充值、参与返利及使用账户余额。
          </p>
          <section>
            <h4>一、名词定义</h4>
            <p>
              <b>1、购买金额：</b>
              您通过“远程慧联APP”向您已注册的用户账号实际支付的金额。{" "}
            </p>
            <p>
              <b>2、账户余额：</b>
              包括充值本金、参与“充值返利”活动赠送的返利金额、参与其他活动赠送的奖励金额。
            </p>
          </section>
          <section>
            <h4>二、账户余额有效期</h4>
            <p>用户账户余额的有效期为自充值之日起至使用完毕为止。</p>
          </section>
          <section>
            <h4>三、账户余额的使用规则</h4>
            <p>
              用户账号使用期间，购买的充电卡只能用于充电使用，且已购买的充电卡不能申请退款。
            </p>
          </section>
          <section>
            <h4>四、保证与承诺</h4>
            <p>
              您完全理解并同意，远程慧联APP所提供的购买相关的活动优惠仅适用于正当、合法按照《用户协议》使用我们服务的用户。一旦发现您的用户账号存在任何利用前述规则从事作弊行为以获取不正当经济利益的情形，远程慧联APP有权冻结或关闭您的用户账号以及任何其他与作弊行为相关的用户账号、并且远程慧联APP保留停止向您提供服务以及根据作弊行为的严重程度进一步追究法律责任的权利。
            </p>
          </section>
          <section>
            <h4>五、特别说明</h4>
            <p>
              您完全理解并同意，远程慧联APP所提供的购买相关的活动优惠仅适用于正当、合法按照《用户协议》使用我们服务的用户。一旦发现您的用户账号存在任何利用前述规则从事作弊行为以获取不正当经济利益的情形，远程慧联APP有权冻结或关闭您的用户账号以及任何其他与作弊行为相关的用户账号、并且远程慧联APP保留停止向您提供服务以及根据作弊行为的严重程度进一步追究法律责任的权利。
            </p>
          </section>
          <p>
            在适用法律法规允许的范围内，本协议下购买、返利、及账户余额的使用规则的最终解释权归远程慧联APP所有。{" "}
          </p>
        </div>
      </div>
    );
  }
}

export default RechargeExplain;



// WEBPACK FOOTER //
// ./src/staticPage/rechargeExplain/index.js